import { variantOptions } from "#ce/components/SpButton/props";

export const props = Object.freeze({
  /**
   * Number of accepted plans, used to build the default trigger label and toggle the search bar.
   *
   * @type {Number}
   * @storybook-control number
   */
  acceptedPlansCount: {
    type: Number,
    required: true,
  },
  /**
   * Endpoint the nested filter fetches the accepted plans from when the modal first opens.
   *
   * @type {String}
   */
  url: {
    type: String,
    required: true,
  },
  /**
   * Overrides the default `View All N Accepted Plans` trigger label.
   *
   * @type {String}
   * @default undefined
   */
  triggerLabel: {
    type: String,
    default: undefined,
  },
  /**
   * Visual variant of the trigger button.
   *
   * @type {String}
   * @default "outlined"
   * @storybook-control select
   */
  triggerVariant: {
    type: String,
    validator: (value) => variantOptions.includes(value),
    default: "outlined",
  },
  /**
   * Heading shown in the modal header.
   *
   * @type {String}
   * @default "All Accepted Insurance Plans"
   */
  modalTitle: {
    type: String,
    default: "All Accepted Insurance Plans",
  },
});
